import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import language from '../../variables/language';
import DraftComposer from './DraftComposer';
import '../../css/exercise-create-modal.css';

// Same composer as the create window, but the result is appended to the exercise
// that is already open. The teacher then edits the new blocks with the normal
// block editors below.
export default function ImportIntoExerciseDialog({ exerciseId, onAdded }) {
   const navigate = useNavigate();
   const t = language[language.lang].screenshotImport;
   const [open, setOpen] = useState(false);
   const [draft, setDraft] = useState(null);
   const [busy, setBusy] = useState(false);
   const [error, setError] = useState('');
   const [doneCount, setDoneCount] = useState(null);

   const close = () => {
      setOpen(false);
      setDraft(null);
      setError('');
      setDoneCount(null);
   };

   const append = () => {
      if (!draft || busy) return;
      setBusy(true);
      setError('');
      axios.post('/api/exercise-ocr/append-blocks', { exerciseId, draft }, { withCredentials: true })
         .then(response => {
            setDoneCount(response.data && response.data.questionCount);
            setDraft(null);
            if (onAdded) onAdded();
         })
         .catch(err => {
            if (err.response && err.response.status === 401) navigate('/login');
            setError(t.createFailed);
         })
         .finally(() => setBusy(false));
   };

   return (
      <>
         <button type='button' className='ecm-btn' onClick={() => setOpen(true)}>{t.importButton}</button>
         {open ? (
            <div className='ecm-overlay' onClick={close}>
               <div className='ecm-panel' onClick={e => e.stopPropagation()}>
                  <header className='ecm-header'>
                     <h3 className='ecm-title'>{t.importTitle}</h3>
                     <button type='button' className='ecm-close' onClick={close} aria-label='Закрити'>×</button>
                  </header>
                  <div className='ecm-body'>
                     <DraftComposer onDraftChange={setDraft} />
                  </div>
                  <footer className='ecm-footer'>
                     {error ? <span className='ecm-error'>{error}</span> : ''}
                     {doneCount !== null ? <span className='ecm-hint'>{t.addedCount}: {doneCount}</span> : ''}
                     <button type='button' className='ecm-btn' onClick={close}>{t.cancel}</button>
                     <button type='button' className='ecm-btn ecm-btn-primary' disabled={!draft || busy} onClick={append}>
                        {busy ? t.creating : t.addToExercise}
                     </button>
                  </footer>
               </div>
            </div>
         ) : ''}
      </>
   );
}
